/**
 * Error helpers
 *
 * Minimal shape for the errors thrown by axios / the API client, used to
 * narrow `unknown` catch clauses without pulling in axios' types everywhere.
 */

export interface ApiErrorShape {
  message?: string;
  code?: string;
  response?: {
    status?: number;
    data?: {
      message?: string;
      error?: string;
    };
  };
}

/** Narrow an unknown catch value to the API error shape. */
export const asApiError = (err: unknown): ApiErrorShape => err as ApiErrorShape;
